import { Capacitor } from '@capacitor/core'

// Platform detection utilities
export const platform = {
  isNative: () => Capacitor.isNativePlatform(),
  isWeb: () => !Capacitor.isNativePlatform(),
  isIOS: () => Capacitor.getPlatform() === 'ios',
  isAndroid: () => Capacitor.getPlatform() === 'android',
  getPlatform: () => Capacitor.getPlatform()
}
